module.exports = __webpack_public_path__ + "img/google-pay.149c1e89.svg";